import { Component, Inject, LOCALE_ID, OnInit } from '@angular/core';
import { UserService } from 'src/app/core/user/user.service';
import { UserQuery } from 'src/app/core/user/user.query';
import { User } from 'src/app/core/user/user.model';
import { WindowService } from '../window/window.service';
import { SettingsComponent } from 'src/app/settings/settings.component';

@Component({
  selector: 'app-user-menu',
  templateUrl: './user-menu.component.html',
  styleUrls: ['./user-menu.component.scss']
})
export class UserMenuComponent implements OnInit {

  user: User;

  constructor(
    private userService: UserService,
    private userQuery: UserQuery,
    private windowService: WindowService,
    @Inject(LOCALE_ID) public locale: string
  ) { }

  ngOnInit(): void {
    this.loadUser();
    this.userQuery.userInfo$.subscribe(
      info => this.user = info.user
    );
  }

  get fullName() {
    const title = $localize`EMPTY`;
    if (!this.user) {
      return;
    }
    if (!this.user.firstname) {
      if (!this.user.lastname) {
        return title;
      }
      return this.user.lastname;
    }
    return `${this.user.firstname} ${this.user.lastname}`;
  }

  openSettings() {
    const titleConfig = $localize`Settings`;
    this.windowService.open({
      title: titleConfig,
      componentType: SettingsComponent,
      help: 'USER_MENU',
    });

  }

  private loadUser() {
    this.userService.get().subscribe();
  }
}
